import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointDesktop } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    width: "100%",
    paddingBottom: "60%",
    height: 0,
    position: "relative",
    border: "1px solid rgba(52, 59, 79, 0.30)",
    borderRadius: theme.radius.large,
    overflow: "hidden",
    [BreakPointDesktop]: {
      height: "100%",
      paddingBottom: 0,
      flex: 1,
      minHeight: 0,
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
  },
  bgImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  desc: {
    marginTop: theme.spacing.space8,
    whiteSpace: "pre-line",
  },
  content: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    padding: `${theme.spacing.space32}px ${theme.spacing.space24}px`,
    boxSizing: "border-box",
  },
  btnAction: {
    position: "absolute",
    bottom: theme.spacing.space32,
    left: theme.spacing.space24,
    borderRadius: theme.radius.large,
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
  },
}));
